import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import LinesEllipsisLoose from 'react-lines-ellipsis/lib/loose';
import { withResizeDetector } from 'react-resize-detector';
import { useStyles } from '@wix/tpa-settings/dist/src/hooks';

import { instagramStyleParams } from '../../../../../settings';
import IconAndText from './IconAndText';
import { DISPLAY_ON_HOVER } from '../../../../../constants/settingsConstants';

import { st, classes } from './ProGalleryHoverItem.st.css';

const ProGalleryHoverItem = ({
  item,
  galleryHoverTextColor,
  galleryHoverFillColor,
  displayOnHover,
  isBusinessApp,
  isMobile,
  width,
  isHover,
  overlayEffect,
}) => {
  const styles = useStyles();
  const hoverItemRef = useRef();
  const [lines, setLines] = useState();
  const CONSTANTS = {
    line_height: 24,
    max_width: 288,
    width_percent: 0.85,
  };
  const isShowCounters = displayOnHover === DISPLAY_ON_HOVER.COUNTERS;

  const editCaptionHandler = () => {
    const itemHeight = hoverItemRef.current?.clientHeight;
    if (itemHeight) {
      const maxLines = Math.floor(itemHeight / CONSTANTS.line_height);
      setLines(maxLines);
    }
  };

  useEffect(() => {
    // if (isEditor && !isShowCounters) {
    if (!isShowCounters) {
      editCaptionHandler();
    }
  }, []);

  if (isMobile) return null;

  galleryHoverTextColor = galleryHoverTextColor
    ? galleryHoverTextColor.value
    : styles.get(instagramStyleParams.galleryHoverTextColor).value;

  galleryHoverFillColor = galleryHoverFillColor
    ? galleryHoverFillColor.value
    : styles.get(instagramStyleParams.galleryHoverFillColor).value;

  const isMedium = width >= 108 && width < 192;
  const caption =
    item.caption && item.caption.text
      ? item.caption.text
      : typeof item.caption === 'object'
      ? ''
      : item.caption;

  const maxCapWidth =
    (hoverItemRef.current?.clientWidth || width || CONSTANTS.max_width) *
      CONSTANTS.width_percent +
    'px';

  return (
    <div
      className={st(classes.root, { isHover, overlayEffect })}
      ref={hoverItemRef}
      style={{
        backgroundColor: galleryHoverFillColor,
      }}
      onMouseEnter={editCaptionHandler}
    >
      {isBusinessApp && isShowCounters ? (
        <div className={isMedium ? '' : st(classes.WarpContent)}>
          <IconAndText
            isLikeIcon={true}
            text={item.like_count || '0'}
            galleryHoverTextColor={galleryHoverTextColor}
            isMedium={isMedium}
          />
          <IconAndText
            isLikeIcon={false}
            text={item.comments_count || '0'}
            galleryHoverTextColor={galleryHoverTextColor}
            isMedium={isMedium}
          />
        </div>
      ) : (
        <div
          className={st(classes.caption, { isMedium })}
          style={{
            color: galleryHoverTextColor,
            maxWidth: maxCapWidth,
          }}
        >
          <LinesEllipsisLoose
            className={classes.ellipsis}
            text={caption}
            maxLine={lines - 2}
            lineHeight={CONSTANTS.line_height}
          />
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  galleryHoverTextColor: state.settingsReducer.galleryHoverTextColor,
  galleryHoverFillColor: state.settingsReducer.galleryHoverFillColor,
  isBusinessApp: state.appReducer.isBusinessApp,
  displayOnHover: state.settingsReducer.displayOnHover,
  isMobile: state.appReducer.isMobile,
  overlayEffect: state.settingsReducer.overlayEffect,
});

export default connect(mapStateToProps)(
  withResizeDetector(ProGalleryHoverItem),
);
